const FRAME_MS = 1000 / 60;
const FIRST_INDIRECT_RETENTION = 0.45;
const THIRD_INDIRECT_RETENTION = 0.05;
const MINIMUM_RETENTION = 0.03;

export function indirectImpactRetention(contactDistance: number, deltaMs = FRAME_MS): number {
  if (!Number.isFinite(contactDistance) || contactDistance <= 1) return 1;
  const indirectDistance = Math.floor(contactDistance) - 1;
  const frameRetention = indirectDistance >= 4
    ? MINIMUM_RETENTION
    : indirectDistance === 3
      ? THIRD_INDIRECT_RETENTION
      : FIRST_INDIRECT_RETENTION ** indirectDistance;
  const frameScale = Number.isFinite(deltaMs) ? Math.max(0, deltaMs) / FRAME_MS : 1;
  return frameRetention ** frameScale;
}
